import { createSlice } from "@reduxjs/toolkit";
import { benefitsApi } from "./benefits.api";
// Api response type
const initialState = {
    benefits: [],
    dictionary: {},
    config: {}
};
export const benefitsSlice = createSlice({
    name: "benefits",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(benefitsApi.endpoints.getBenefits.matchFulfilled, (state, action) => {
            return Object.assign(Object.assign({}, state), action.payload);
        });
    }
});
//# sourceMappingURL=benefits.slice.js.map